import { createFileRoute } from '@tanstack/react-router';

// By path: the feature's index is the layout's, and the tabs are routes of their own.
import { GeneralTab } from '@/features/settings/components/GeneralTab';

export const Route = createFileRoute(
  '/workspaces/$workspaceId/settings/general',
)({
  component: GeneralRoute,
});

export function GeneralRoute() {
  const { workspaceId } = Route.useParams();
  return <GeneralTab workspaceId={workspaceId} />;
}
